import React, {useEffect, useRef, useState} from 'react'
import HeaderCard from "../../common/header-author/Header-Card";
import CardPopularList from "../../cards/CardPopularList";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ArrowRight from "../../icons/ArrowRight";
import {Link} from "react-router-dom";
import "../../../components/cards/cards.css"
import CustomPopup from "../../common/pop-up/CustomPopup";
import MovieModal from "../../modal/MovieModal";
import {get} from "sodon-http/API";
import {API_URL} from "../../../constans/API_URL";
import {useQuery} from "@tanstack/react-query";

export default function Popular() {


    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [isDragging, setIsDragging] = useState(false);

    const { data: seasonData } = useQuery({
        queryKey: ['season',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/stat?type=1&from=2024-01-01&to=2024-03-20&size=10`);
        },
    });

    const { data: allData } = useQuery({
        queryKey: ['all',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/stat?type=1&from=2024-01-01&to=2024-03-20&size=10`);
        },
    });

    const { data: yearData } = useQuery({
        queryKey: ['year',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/stat?type=1&from=2024-01-01&to=2024-03-20&size=10`);
        },
    });

    const season = seasonData?.payload;
    const all = allData?.payload;
    const year = yearData?.payload;


    function openDialog(item) {
        setSelectedItem(item);
        setIsDialogOpen(true);
    }

    function handleClose(e) {
        setIsDialogOpen(false);
    }



    return (
        <div className={"container"}>
            <HeaderCard title={"Хамгийн их хандалттай төслүүд"}/>
            <Tabs className={"popular__tabs mt-5"} selectedTabClassName="popular_react-tabs__tab__selected">
                <div className={"flex justify-between items-center"}>
                    <TabList className={"popular__tab-list"}>
                        <Tab className={"popular_react-tabs__tab"} >
                            Бүх цаг үед
                        </Tab>
                        <Tab className={"popular_react-tabs__tab"}>
                            Энэ улирал
                        </Tab>
                        <Tab className={"popular_react-tabs__tab"}>
                            Энэ жил
                        </Tab>
                    </TabList>
                    <Link to={"/popular"}>
                        <div className="button-more button-original-outline">
                            Цааш үзэх
                            <ArrowRight color="#00b3ff"/>
                        </div>
                        <div className="button-mobile">
                            <ArrowRight color="#A7A5A5"/>
                        </div>
                    </Link>
                </div>
                <TabPanel>
                    <div className={"mt-5 grid xl:grid-cols-3 lg:grid-cols-3 gap-4 md:grid-cols-2 sm:grid-cols-2 max-sm:grid-cols-1"}>
                        {
                            all && all.map((item, index) => (
                                <CardPopularList key={index} item={item.movie}
                                                 onClick={() => {
                                                     if (!isDragging) {
                                                         openDialog(item.movie);
                                                     }
                                                 }}
                                />
                            ))
                        }
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className={"mt-5 grid xl:grid-cols-3 lg:grid-cols-3 gap-4 md:grid-cols-2 sm:grid-cols-2 max-sm:grid-cols-1"}>
                        {
                            season && season.map((item, index) => (
                                <CardPopularList key={index} item={item.movie}  onClick={() => {openDialog(item.movie)}} />
                            ))
                        }
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className={"mt-5 grid xl:grid-cols-3 lg:grid-cols-3 gap-4 md:grid-cols-2 sm:grid-cols-2 max-sm:grid-cols-1"}>
                        {
                            year && year.map((item, index) => (
                                <CardPopularList key={index} item={item.movie}  onClick={() => {openDialog(item.movie)}} />
                            ))
                        }
                    </div>
                </TabPanel>
                <CustomPopup open={isDialogOpen} close={handleClose}>
                    <MovieModal
                        item={selectedItem}
                        shown={isDialogOpen}
                        setShown={value => setIsDialogOpen(value)}
                    />
                </CustomPopup>
            </Tabs>



        </div>
    )
}
